/**
 * A class linking a material and one or more account.
 */
export class AccountDetailsByMaterial {
    /**
     * Create an AccountDetailsByMaterial object
     * @param {Material} material
     * @param {Account[]} accounts
     */
    constructor(
        material,
        accounts,
    ) {
        this._material = material;
        this._accounts = accounts;
    }

    /**
     * Get all the information about the getAccountDetailsByMaterial
     * @return {{material_id: number, accounts: {accountStatus: string, consumptionLevel: string, itemCategory: {label: string, value: string}, accountType: {label: string, value: string}, glNumber: {label: string, value: string}, allocateFor: number, accountNumber: ({label: string, value: string}|{label: string, value: string}[]), allocationType: string}[]}}
     */
    getAccountDetailsByMaterial() {
        return {
            material_id: this._material?.id,
            accounts: this._accounts.map((account) => account.getAccount()),
        };
    }

    /**
     * Get all the information about the getFirstAccountDetailsByMaterial
     * @return {{material_id: number, accounts: {accountStatus: string, consumptionLevel: string, itemCategory: {label: string, value: string}, accountType: {label: string, value: string}, glNumber: {label: string, value: string}, allocateFor: number, accountNumber: ({label: string, value: string}|{label: string, value: string}[]), allocationType: string}[]}}
     */
    getFirstAccountDetailsByMaterial() {
        return {
            material_id: this._material.id,
            accounts: this._accounts.map((account) => account),
        };
    }
    /**
     * Get the material value.
     * @return {Material} The material value.
     */
    get material() {
        return this._material;
    }

    /**
     * Set the material value.
     * @param {Material} value to set
     */
    set material(value) {
        this._material = value;
    }

    /**
     * Get the accounts value.
     * @return {Account[]} The accounts value.
     */
    get accounts() {
        return this._accounts;
    }

    /**
     * Set the accounts value.
     * @param {Account[]} value to set
     */
    set accounts(value) {
        this._accounts = value;
    }
}
